'use client';

import useSWR from 'swr';

import type {
  IUserStorageItem,
  IUserStorageItemsResponse,
} from '@/api/userStorage';
import { fetcherSS } from '@/modules/api';
import { useInfoProject } from '@/modules/common';
import { useGetCommonStore } from '@/store';
import { userStorageKeys } from '../keys';

export const useUserStorageItems = () => {
  const useCommonStore = useGetCommonStore();
  const isAuthenticated = useCommonStore.use.isAuthenticated();

  const { data: project } = useInfoProject();
  const isAvailable = isAuthenticated && !!project?.userStorageItems;

  const { data, error, isLoading, mutate } = useSWR<IUserStorageItem[]>(
    isAvailable ? userStorageKeys.all : null,
    (key: string) =>
      fetcherSS<IUserStorageItemsResponse | null>(key).then(
        (res) => res?.data ?? []
      )
  );

  const isReady = !(isAvailable && isLoading);

  return {
    items: data ?? [],
    isLoading,
    isReady,
    isAvailable,
    error,
    mutate,
  };
};
